const LOGO_WRAPPER_CLASSNAME = 'lg:mr-40';
export { LOGO_WRAPPER_CLASSNAME };
